import { c as _c } from "react/compiler-runtime";
import { SphereSupportLink } from "@components/common/sphere-support-link";
import { ContactSupportLocations } from "@custom-types/types";
import { Banner } from "@flat-ui";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useRouteMatch } from "@hooks/use-route-match";
import { Box } from "@mui-wrapper";
import { topPriorityXgSubscriptionSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { getSubscriptionRemainingDays, isTrialSubscription } from "@utils/subscription-utils";
import { useState } from "react";

/** Default remaining days to start showing the banner */
const DEFAULT_DAYS = 7;
/** Banner to show when a subscription almost ended in {days} days */
export function SubscriptionExpirationBanner(t0) {
  const $ = _c(7);
  const {
    alertThresholdDays: t1
  } = t0;
  const alertThresholdDays = t1 === undefined ? DEFAULT_DAYS : t1;
  const routeIdentifier = useRouteMatch();
  const subscription = useAppSelector(topPriorityXgSubscriptionSelector);
  const isTrial = isTrialSubscription(subscription);
  const [isDismissed, setIsDismissed] = useState(false);
  const {
    canViewSubscriptionDetails
  } = useHasUserValidRoleCompanyLevel();
  let t2;
  if ($[0] !== alertThresholdDays || $[1] !== subscription) {
    t2 = getSubscriptionRemainingDays(subscription) ?? alertThresholdDays + 1;
    $[0] = alertThresholdDays;
    $[1] = subscription;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const remainingDays = t2;
  const shouldShowBanner = routeIdentifier !== "subscriptionExpired" && remainingDays <= alertThresholdDays && !isDismissed && !isTrial && canViewSubscriptionDetails;
  if (!shouldShowBanner) {
    return null;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsDismissed(true);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SphereSupportLink location={ContactSupportLocations.subscriptionExpiredBanner} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== remainingDays) {
    t5 = <Box data-testid="expiration-subscription-banner"><Banner variant="warning" onClose={t3} title="Subscription ending soon"><div>Your subscription will expire in {remainingDays} days. Renew now to avoid interruptions, or contact{" "}{t4}{" "}for further information.</div></Banner></Box>;
    $[5] = remainingDays;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}